import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/layout/SiteLayout";
import AdminLayout from "@/components/admin/AdminLayout";
import Home from "@/pages/Home";
import Interviews from "@/pages/Interviews";
import InterviewDetail from "@/pages/InterviewDetail";
import Watch from "@/pages/Watch";
import Listen from "@/pages/Listen";
import Use from "@/pages/Use";
import Operators from "@/pages/Operators";
import OperatorDetail from "@/pages/OperatorDetail";
import Topics from "@/pages/Topics";
import TopicDetail from "@/pages/TopicDetail";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import Collections from "@/pages/Collections";
import CollectionDetail from "@/pages/CollectionDetail";
import About from "@/pages/About";
import Manifesto from "@/pages/Manifesto";
import Contribute from "@/pages/Contribute";
import Nominate from "@/pages/Nominate";
import Newsletter from "@/pages/Newsletter";
import Contact from "@/pages/Contact";
import Partner from "@/pages/Partner";
import SearchPage from "@/pages/SearchPage";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminInterviews from "@/pages/admin/AdminInterviews";
import AdminInterviewEdit from "@/pages/admin/AdminInterviewEdit";
import AdminOperators from "@/pages/admin/AdminOperators";
import AdminTopics from "@/pages/admin/AdminTopics";
import AdminIndustries from "@/pages/admin/AdminIndustries";
import AdminCollections from "@/pages/admin/AdminCollections";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/read" element={<Interviews />} />
            <Route path="/interviews" element={<Interviews />} />
            <Route path="/interviews/:slug" element={<InterviewDetail />} />
            <Route path="/read/:slug" element={<InterviewDetail />} />
            <Route path="/watch" element={<Watch />} />
            <Route path="/listen" element={<Listen />} />
            <Route path="/use" element={<Use />} />
            <Route path="/operators" element={<Operators />} />
            <Route path="/operators/:slug" element={<OperatorDetail />} />
            <Route path="/topics" element={<Topics />} />
            <Route path="/topics/:slug" element={<TopicDetail />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/industries/:slug" element={<IndustryDetail />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/collections/:slug" element={<CollectionDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/manifesto" element={<Manifesto />} />
            <Route path="/contribute" element={<Contribute />} />
            <Route path="/nominate" element={<Nominate />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/partner" element={<Partner />} />
            <Route path="/sponsor" element={<Partner />} />
            <Route path="/search" element={<SearchPage />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/interviews" element={<AdminInterviews />} />
            <Route path="/admin/interviews/new" element={<AdminInterviewEdit />} />
            <Route path="/admin/interviews/:slug" element={<AdminInterviewEdit />} />
            <Route path="/admin/operators" element={<AdminOperators />} />
            <Route path="/admin/topics" element={<AdminTopics />} />
            <Route path="/admin/industries" element={<AdminIndustries />} />
            <Route path="/admin/collections" element={<AdminCollections />} />
            <Route path="/admin/submissions" element={<AdminSubmissions />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster position="bottom-center" richColors closeButton />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
